namespace appn.trash {
    export function deleteConfirm($parentForm: JQuery<HTMLElement>, submitType: string, ignoreValidation: any, msgDetail?: string, msgOverride?: string) {
        const detail = elementBuilder.createElement('p', undefined, undefined, undefined, T('The selected item(s) will be permanently deleted.'));
        if (msgDetail)
            detail.innerHTML = msgDetail;

        const message = elementBuilder.createElement('p', undefined, undefined, undefined, T('This action can not be undone.'));
        if (msgOverride || msgOverride === emptyString)
            message.innerHTML = msgOverride;

        const confirmation = elementBuilder.createElement('p', 'trash-confirm-msg', undefined, undefined, T('Hit the <b>Delete</b> button to proceed.'));

        const buttonConfig = {
            confirm: {
                label: '<span>' + T('Delete') + '</span><i class="fa fa-times-circle"></i>',
                className: 'btn-danger',
                callback: function(result: any) {
                    if (result) {
                        // Finally submit the form
                        $parentForm.append('<input type="hidden" name="submitType" value="' + submitType + '" />');

                        if (ignoreValidation)
                            ($parentForm.validate() as any).cancelSubmit = true;

                        $parentForm.submit();
                    }
                }
            }
        };

        appn.dialog.custom({
            modalColor: 'modal-danger',
            title: T('Confirm Delete'),
            message: detail.outerHTML + (message.outerHTML.length > 0 ? message.outerHTML : emptyString) + confirmation.outerHTML,
            className: 'appnGlobalConfirmDelete',
            isDeleteAction: true,
            closeButton: true,
            buttons: buttonConfig
        });
    }

    export function trashConfirm($parentForm: JQuery<HTMLElement>, submitType: string, msgDetail?: string, msgOverride?: string) {
        let detail = elementBuilder.createElement('p', undefined, undefined, undefined, T('The selected item(s) will be moved to Trash and will no longer be available for use.'));
        if (msgDetail)
            detail.innerHTML = msgDetail;

        const message = elementBuilder.createElement('p', undefined, undefined, undefined, T('You will have 30 days to restore from the Trash area before the item(s) are permanently deleted from the system.'));
        if (msgOverride)
            message.innerHTML = msgOverride;

        const confirmation = elementBuilder.createElement('p', 'trash-confirm-msg', undefined, undefined, T('Hit the <b>Trash</b> button to proceed.'));

        const buttonConfig = {
            trash: {
                label: '<span>' + T('Trash') + '</span><i class="fa fa-trash"></i>',
                className: 'btn-danger',
                callback: function(result: any) {
                    if (result) {
                        // Finally submit the form
                        $parentForm.append('<input type="hidden" name="submitType" value="' + submitType + '" />');

                        ($parentForm.validate() as any).cancelSubmit = true;

                        $parentForm.submit();
                    }
                }
            }
        };

        appn.dialog.custom({
            modalColor: 'modal-danger',
            title: T('Move To Trash?'),
            message: detail.outerHTML + message.outerHTML + confirmation.outerHTML,
            className: 'appnGlobalConfirmTrash',
            isTrashAction: true,
            closeButton: true,
            buttons: buttonConfig
        });
    }

    /**
     * Gets details from the view to display in the trash message using selectors
     */
    export function getTrashDetailsFromTable(name: JQuery<HTMLElement>, version?: JQuery<HTMLElement>, status?: JQuery<HTMLElement>): TrashItem {
        return {
            name: (cleanCellText(name) as string),
            version: version ? Number(version.text()) : undefined,
            status: status ? status.text() as string : undefined
        };
    }

    export function createTrashMessageFromTable(button: JQuery<HTMLElement>, selectedRows: any, itemsType: string, nameCol: number = 1, versionCol?: number, statusCol?: number) {
        let msg;
        button.attr('data-trashdetail', emptyString);

        const headers = $('table.dataTable[id] thead tr th');

        headers.each(function(index: number, value: HTMLElement) {
            const headerText = $(value).find('div').text();
            switch (headerText.trim()) {
                case 'Version':
                    versionCol = index;
                    break;
                case 'Status':
                    statusCol = index;
                    break;
            }
        });

        if (selectedRows.length > 1) { // If we have multiple items
            const ul = elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
            selectedRows.each(function(index: number, selected: JQuery<HTMLElement>) {
                const trashItem = trash.getTrashDetailsFromTable($($(selected).closest('tr').find('td')[nameCol]),
                    versionCol ? $($(selected).closest('tr').find('td')[versionCol]) : undefined,
                    statusCol ? $($(selected).closest('tr').find('td')[statusCol]) : undefined);

                let itemMsg = `<b>${trashItem.name}`;

                if (trashItem.version) {
                    itemMsg += ` (${T('Version')} ${trashItem.version}`;

                    if (trashItem.status)
                        itemMsg += ` - ${trashItem.status}`;

                    itemMsg += `)`;
                }

                itemMsg += '</b>';

                const li = elementBuilder.createElement('li', undefined, undefined, undefined, itemMsg);
                ul.appendChild(li);
            });

            msg = T('The following <b>{0}</b> and all associated data/versions will be moved to Trash.', itemsType) + ul.outerHTML;
        } else { // if we have a single item
            const trashItem = trash.getTrashDetailsFromTable($($(selectedRows[0]).closest('tr').find('td')[nameCol]),
                versionCol ? $($(selectedRows[0]).closest('tr').find('td')[versionCol]) : undefined,
                statusCol ? $($(selectedRows[0]).closest('tr').find('td')[statusCol]) : undefined);

            let itemMsg = `<b>${trashItem.name} `;

            if (trashItem.version) {
                itemMsg += `(${T('Version')} ${trashItem.version}`;

                if (trashItem.status)
                    itemMsg += ` - ${trashItem.status}`;

                itemMsg += `)`;
            }

            itemMsg += '</b>';

            msg = T('{0} and all associated data/versions will be moved to Trash.', itemMsg);
        }

        const p = elementBuilder.createElement('p', undefined, undefined, undefined, msg);

        button.attr('data-trashdetail', JSON.stringify(p.outerHTML));
    }

    export function addTrashMessage(button: JQuery<HTMLElement>, nameSelect: string, versionSelect?: string, statusSelect?: string, hasVersions: boolean = true) {
        const trashAll = (button.val() as string).containsIgnoreCase('TrashAll');
        const isTrash = (button.val() as string).containsIgnoreCase('Trash');
        const isdelete = (button.val() as string).containsIgnoreCase('Delete');

        if (isTrash)
            button.attr('data-trashdetail', emptyString);

        if (isdelete)
            button.attr('data-deletedetail', emptyString);

        const trashItem: appn.trash.TrashItem = {
            name: $(`${nameSelect}`).val() as string,
            version: Number($(`label[for="${versionSelect}"]`).closest('.form-group').find('.col-md-7 .col-form-label').text()),
            status: $(`label[for="${statusSelect}"]`).closest('.form-group').find('.col-md-7 .col-form-label').text()
        };

        let itemMsg = `<b>${trashItem.name}`;

        if (trashItem.version) {
            itemMsg += ` (${T('Version')} ${trashItem.version}`;

            if (trashItem.status)
                itemMsg += ` - ${trashItem.status}`;

            itemMsg += `)`;
        }

        itemMsg += '</b>';

        let msg = `${isdelete ? T('{0} will be permanently deleted.', itemMsg) : T('{0} will be moved to Trash and will no longer be available for use.', itemMsg)}${hasVersions ? T('<p><b>Note:</b> Only the current version will be moved to Trash.<p>') : ''}`;
        if (trashAll)
            msg = T('{0} and all associated data {1}will be moved to Trash.', itemMsg, hasVersions ? T('(including ALL versions) '): '');

        if (isTrash)
            button.attr('data-trashdetail', JSON.stringify(msg));

        else if (isdelete)
            button.attr('data-deletedetail', JSON.stringify(msg));
    }

    export function addConnectorDeleteMessage(button: JQuery<HTMLElement>) {
        button.attr('data-deletedetail', emptyString);
        button.attr('data-deletemessage', emptyString);

        const desc = button.closest('.connector').find('.card-header input[id^="Connectors"]').val();

        const msg = T('<b>{0}</b> is about to be permanently disconnected and deleted.', desc);

        button.attr('data-deletedetail', JSON.stringify(msg));
        button.attr('data-deletemessage', ' '); // Make default message disappear
    }

    export function cleanCellText(cell: JQuery<HTMLElement>): string {
        return cell.clone()
            .find('.dt-titleText')
            .text()
            .trim();
    }

    export interface TrashItem {
        name: string;
        version: number | undefined;
        status: string | undefined;
    }
}
